import Vue from 'vue';
import axios from 'axios';
import { gmapApi } from 'vue2-google-maps';
import gMapStyles from '@/assets/json/gmapstyles.json';

export default {
  name: 'GoogleMapElements',
  props: ['dataObj'],
  data: function () {
    return {
      geoLocation: null,
      gMapPosition: { lat: 0, lng: 0 },
      accuracy: 0,
      gMapPositionStart: { lat: 0, lng: 0 },
      gMapPositionMove: { lat: 0, lng: 0 },
      markerTitle: this.$t('messages.MarkerTitle'),
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -50
        }
      },
      layers: [],
      bDraggable: true,
      bClickable: true,
      bEditLocation: false,
      errorMessage: '',
      message: '',
      mapStyles: gMapStyles,
      layersBool: [],
      features: null,
      layersVisible: true,
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {

  },
  created() {
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    setInterval(this.getMapX, 100);
    if (!this.dataObj.latitude && !this.dataObj.longitude && this.dataObj.elementTypeId === -1 && this.dataObj.elementId === -1) {
      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gMapPosition.lat = pos.coords.latitude;
          this.gMapPosition.lng = pos.coords.longitude;
          this.dataObj.latitude = pos.coords.latitude;
          this.dataObj.longitude = pos.coords.longitude;
          this.accuracy = pos.coords.accuracy;
        },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );
    }
    this.$root.$on('gmap_element_updated', this.init);
    if (this.dataObj.latitude && this.dataObj.longitude && this.dataObj.latitude !== 0 && this.dataObj.longitude !== 0)
      this.getElementsByLngLat();
    if (this.dataObj.elementTypeId && this.dataObj.elementId && this.dataObj.elementTypeId > -1 && this.dataObj.elementId > -1)
      this.getElementsByIdType();
  },
  methods: {
    getMapX() {
      var msg = localStorage.getItem("map-x");
      localStorage.removeItem('map-x');
      if (msg && msg.indexOf('Selected') > -1) {
        this.$alertMsg(this.$t('common.elementSelected'), 1);
        return;
      }
      if (msg)
        this.$alertMsg(msg, 1);
    },
    init() {
      Vue.nextTick(() => {
        this.markerTitle = 'Marker Title';
        this.bDraggable = true;
        this.bClickable = true;
        if (this.gMapPosition.lat === 0)
          this.getGeoLocation();
      });
    },
    setControl(controlDiv, textCode, index) {
      // Set CSS for the control border.
      const controlUI = document.createElement("div");
      controlUI.style.backgroundColor = "#fff";
      controlUI.style.border = "1px solid #fff";
      controlUI.style.borderColor = "#c8c8c8";
      controlUI.style.borderRadius = "3px";
      controlUI.style.boxShadow = "0 2px 2px rgba(0,0,0,.3)";
      controlUI.style.cursor = "pointer";
      controlUI.style.marginBottom = "8px";
      controlUI.style.marginLeft = "10px";
      controlUI.style.textAlign = "center";
      controlUI.title = "Click to show/hide layer";
      controlDiv.appendChild(controlUI);
      // Set CSS for the control interior.
      const controlText = document.createElement("div");
      controlText.style.color = "rgb(25,25,25)";
      controlText.style.fontFamily = "Roboto,Arial,sans-serif";
      controlText.style.fontSize = "16px";
      controlText.style.lineHeight = "30px";
      controlText.style.paddingLeft = "5px";
      controlText.style.paddingRight = "5px";
      controlText.innerHTML = textCode;
      controlUI.appendChild(controlText);
      controlUI.addEventListener("click", () => {
        var map = this.$refs.myMap;
        if (this.layersBool[index] === false) {
          this.layersBool[index] = true;
          controlUI.style.borderColor = "#0ba6d3";
          controlUI.style.backgroundColor = "#c0f0ff";
          this.features = map.$mapObject.data.addGeoJson(this.layers[index].geoJson);
          map.$mapObject.data.forEach(function (feature) {
            feature.setProperty('isSelected', false);
          });
        }
        else {
          controlUI.style.borderColor = "#c8c8c8";
          controlUI.style.backgroundColor = "#fff";
          this.layersBool[index] = false;
          map.$mapObject.data.forEach(function (feature) {
            // filter...
            map.$mapObject.data.remove(feature);
          });
          var i = 0;
          this.layers.forEach(item => {
            if (this.layersBool[i])
              map.$mapObject.data.addGeoJson(this.layers[i].geoJson);
            i++;
          });
        }

        map.$mapObject.data.setStyle((feature) => {

          //feature.setProperty('isSelected', false);
          var elTYPE = feature.getProperty('elementTypeStr');
          
          var colorStroke = feature.getProperty("color");
          var elemColor = 'black';
          var elemIcon = 'https://icons.iconarchive.com/icons/icons-land/vista-map-markers/48/Map-Marker-Ball-Right-Azure-icon.png';

          var mapStyle = this.mapStyles.filter(item => item.name === elTYPE);
          if (mapStyle && mapStyle.length > 0) {
            elemIcon = mapStyle[0].icon;
            elemColor = mapStyle[0].color;
          }

          return /** @type {!google.maps.Data.StyleOptions} */ {
            icon: elemIcon,
            fillColor: colorStroke,
            strokeColor: elemColor,
            strokeWeight: 4,
          };
        });

        map.$mapObject.data.addListener('click', function (event) {
          var strID = event.feature.getProperty('ID');
          var strNAME = event.feature.getProperty('NAME');
          var isSelected = event.feature.getProperty('isSelected');
          isSelected = !isSelected;
          event.feature.setProperty('isSelected', isSelected);
          var geo = event.feature.getGeometry();
          if (geo.getType().toLowerCase() === 'point') {
            var elLOCATION = 'lat: ' + geo.get().lat() + ', lng: ' + geo.get().lng();
            localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION);
          }
          if (geo.getType().toLowerCase() === 'multilinestring') {
            var elLOCATION = '';
            geo.forEachLatLng(function (latlng) {
              elLOCATION += 'lat: ' + latlng.lat() + ', lng: ' + latlng.lng() + '\n';
            });
            localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION);
          }
        });

        map.$mapObject.data.addListener('dblclick', function (event) {
          var strID = event.feature.getProperty('ID');
          var strNAME = event.feature.getProperty('NAME');
          var isSelected = event.feature.getProperty('isSelected');
          isSelected = !isSelected;
          event.feature.setProperty('isSelected', isSelected);
          var geo = event.feature.getGeometry();
          if (geo.getType().toLowerCase() === 'point') {
            var elLOCATION = 'lat: ' + geo.get().lat() + ', lng: ' + geo.get().lng();
            localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
          }
          if (geo.getType().toLowerCase() === 'multilinestring') {
            var elLOCATION = '';
            geo.forEachLatLng(function (latlng) {
              elLOCATION += 'lat: ' + latlng.lat() + ', lng: ' + latlng.lng() + '\n';
            });
            localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION + ', Selected');
          }
        });

        map.$mapObject.data.addListener('mouseover', function (event) {
          var isSelected = event.feature.getProperty('isSelected');
          map.$mapObject.data.revertStyle();
          map.$mapObject.data.overrideStyle(event.feature, { strokeWeight: 10, strokeColor: '#ffe40c' });

          var geo = event.feature.getGeometry();
          if (geo.getType().toLowerCase() === 'point') {
            var elLOCATION = 'lat: ' + geo.get().lat() + ', lng: ' + geo.get().lng();
            map.$mapObject.data.revertStyle();
            map.$mapObject.data.overrideStyle(event.feature, {
              icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
            });
          }
        });

        map.$mapObject.data.addListener('mouseout', function (event) {
          map.$mapObject.data.revertStyle();
        });

      });
    },
    getElementsByIdType() {
      this.gMapPosition.lat = this.dataObj.latitude;
      this.gMapPosition.lng = this.dataObj.longitude;
      this.$store.state.notifier.asyncBlock(
        axios.get('/Element/GetElementsByLngLat?elementTypeId=' + this.dataObj.elementTypeId + '&elementId=' + this.dataObj.elementId),
        response => {
          if (response.status == 200) {
            this.layers = response.data.layers;
            var map = this.$refs.myMap;
            if (this.layers.length > 0) {
              var layerType = this.layers[0].geoJson.features[0].geometry.type;
              if (layerType === 'Point') {
                var coords = this.layers[0].geoJson.features[0].geometry.coordinates;
                this.gMapPosition.lng = coords[0];
                this.gMapPosition.lat = coords[1];
              } else {
                var coords = this.layers[0].geoJson.features[0].geometry.coordinates[0][0];
                this.gMapPosition.lng = coords[0];
                this.gMapPosition.lat = coords[1];
              }

              this.layers.forEach(layer => map.$mapObject.data.addGeoJson(layer.geoJson));
              map.$mapObject.data.setStyle((feature) => {

                //feature.setProperty('isSelected', false);
                var elTYPE = feature.getProperty('elementTypeStr');

                var colorStroke = feature.getProperty("color");
                var elemColor = 'black';
                var elemIcon = 'https://icons.iconarchive.com/icons/icons-land/vista-map-markers/48/Map-Marker-Ball-Right-Azure-icon.png';

                var mapStyle = this.mapStyles.filter(item => item.name === elTYPE);
                if (mapStyle && mapStyle.length > 0) {
                  elemIcon = mapStyle[0].icon;
                  elemColor = mapStyle[0].color;
                }

                return /** @type {!google.maps.Data.StyleOptions} */ {
                  icon: elemIcon,
                  fillColor: colorStroke,
                  strokeColor: elemColor,
                  strokeWeight: 4,
                };
              });

              map.$mapObject.data.addListener('click', function (event) {
                var strID = event.feature.getProperty('ID');
                var strNAME = event.feature.getProperty('NAME');
                var isSelected = event.feature.getProperty('isSelected');
                isSelected = !isSelected;
                event.feature.setProperty('isSelected', isSelected);
                var geo = event.feature.getGeometry();
                if (geo.getType().toLowerCase() === 'point') {
                  var elLOCATION = 'lat: ' + geo.get().lat() + ', lng: ' + geo.get().lng();
                  localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION);
                }
                if (geo.getType().toLowerCase() === 'multilinestring') {
                  var elLOCATION = '';
                  geo.forEachLatLng(function (latlng) {
                    elLOCATION += 'lat: ' + latlng.lat() + ', lng: ' + latlng.lng() + '\n';
                  });
                  localStorage.setItem('map-x', 'Element: id = ' + strID + ', name = ' + strNAME + ', location: ' + elLOCATION);
                }
              });

              map.$mapObject.data.addListener('mouseover', function (event) {
                var isSelected = event.feature.getProperty('isSelected');
                map.$mapObject.data.revertStyle();
                map.$mapObject.data.overrideStyle(event.feature, { strokeWeight: 10, strokeColor: '#ffe40c' });

                var geo = event.feature.getGeometry();
                if (geo.getType().toLowerCase() === 'point') {
                  var elLOCATION = 'lat: ' + geo.get().lat() + ', lng: ' + geo.get().lng();
                  map.$mapObject.data.revertStyle();
                  map.$mapObject.data.overrideStyle(event.feature, {
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                  });
                }
              });

              map.$mapObject.data.addListener('mouseout', function (event) {
                map.$mapObject.data.revertStyle();
              });

              // zoom to map bounds created by LatLngBounds
              //var bounds = new this.google.maps.LatLngBounds();
              //map.$mapObject.data.forEach(function (feature) {
              //  feature.getGeometry().forEachLatLng(function (latlng) {
              //    bounds.extend(latlng);
              //  });
              //});
              //map.$mapObject.fitBounds(bounds);
            }
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    getElementsByLngLat() {
      var sUrl = '/Element/GetElementsByLngLat?longitude=' + this.dataObj.longitude + '&latitude=' + this.dataObj.latitude;
      if (this.dataObj.elementTypeId > -1)
        sUrl = sUrl + '&elementTypeId=' + this.dataObj.elementTypeId.toString();
      this.$store.state.notifier.asyncBlock(
        axios.get(sUrl),
        response => {
          if (response.status == 200) {
            this.layers = response.data.layers;
            var map = this.$refs.myMap;
            if (this.layers.length > 0) {
              const layerBtn = document.createElement("div");
              layerBtn.className += 'class-layer-1'
              const controlText = document.createElement("div");
              controlText.className += 'class-layer-2'
              controlText.innerHTML = 'Show/Hide Layers';
              layerBtn.appendChild(controlText);
              layerBtn.addEventListener("click", () => {
                this.layersVisible = !this.layersVisible;
                var idx = 0;
                this.layers.forEach(item => {
                  var btnTggl = document.getElementById('mapToggle' + idx);
                  if (btnTggl && this.layersVisible)
                    btnTggl.style.display = "block";
                  else
                    btnTggl.style.display = "none";
                  idx++;
                });
              });
              map.$mapObject.controls[this.google.maps.ControlPosition.LEFT_TOP].push(layerBtn);
            }
            var i = 0;
            this.layers.forEach(item => {
              this.layersBool.push(false);
              const mapBtn = document.createElement("div");
              mapBtn.id = 'mapToggle' + i;
              this.setControl(mapBtn, item.name + ' - ' + item.elementTypeName, i);
              map.$mapObject.controls[this.google.maps.ControlPosition.LEFT_TOP].push(mapBtn);
              i++;
            });
            this.gMapPosition.lat = this.dataObj.latitude;
            this.gMapPosition.lng = this.dataObj.longitude;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Caching Map Elements'
      );
    },
    getGeoLocation() {
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gMapPosition.lat = pos.coords.latitude;
          this.gMapPosition.lng = pos.coords.longitude;
          this.accuracy = pos.coords.accuracy;
        },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );
    },
    gMapDragEnd(evnt) {
      this.gMapPosition.lat = evnt.lat();
      this.gMapPosition.lng = evnt.lng();
      this.dataObj.gMapPosition.lat = evnt.lat();
      this.dataObj.gMapPosition.lng = evnt.lng();
      //this.bEditLocation = false;
      //this.dataObj.bEditLocation = false;
      this.$alertMsg(this.$t('messages.LocationPointSuccess'), 2);
    },
    gMapDrag(evnt) {
      this.gMapPositionMove.lat = evnt.lat();
      this.gMapPositionMove.lng = evnt.lng();
    },
    gMapDragStart(evnt) {
      this.gMapPositionStart.lat = evnt.lat();
      this.gMapPositionStart.lng = evnt.lng();
    },
    toggleInfoWindow: function (evnt) {
      this.gMapPositionMove.lat = evnt.lat();
      this.gMapPositionMove.lng = evnt.lng();
      this.infoWindowPos = this.gMapPositionMove;
      this.infoWinOpen = !this.infoWinOpen;
    },
    closeMapDialog() {
      this.bEditLocation = false;
      this.dataObj.bEditLocation = false;
    },
    getStyle(elemType) {

    }
  }

}
